import React, { useState } from 'react';

interface JsonViewerProps {
    data: any;
    title?: string;
    maxHeight?: string;
}

const JsonViewer: React.FC<JsonViewerProps> = ({ data, title, maxHeight = '400px' }) => {
    const [copied, setCopied] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);

    // Helper to parse if string, otherwise return as is
    const parsedData = React.useMemo(() => {
        if (typeof data === 'string') {
            try {
                return JSON.parse(data);
            } catch (e) {
                return data;
            }
        }
        return data;
    }, [data]);

    const handleCopy = () => {
        const textToCopy = typeof data === 'string' ? data : JSON.stringify(data, null, 2);
        navigator.clipboard.writeText(textToCopy).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    if (!data) {
        return <div className="text-muted small fst-italic">No data available</div>;
    }

    return (
        <div className="card border shadow-sm mb-3">
            <div className="card-header bg-light d-flex justify-content-between align-items-center py-2">
                <div className="d-flex align-items-center cursor-pointer" onClick={() => setIsCollapsed(!isCollapsed)}>
                    <i className={`bi bi-chevron-${isCollapsed ? 'right' : 'down'} me-2 text-muted small`}></i>
                    <span className="fw-bold text-secondary small text-uppercase">{title || 'JSON Data'}</span>
                </div>
                <div>
                    <button
                        className="btn btn-sm btn-outline-secondary py-0 px-2"
                        onClick={handleCopy}
                        title="Copy to clipboard"
                    >
                        {copied ? <i className="bi bi-check2 text-success"></i> : <i className="bi bi-clipboard"></i>}
                        <span className="ms-1 d-none d-sm-inline small">{copied ? 'Copied' : 'Copy'}</span>
                    </button>
                </div>
            </div>

            {!isCollapsed && (
                <div className="card-body p-0 position-relative">
                    <pre
                        className="m-0 p-3 bg-white font-monospace small"
                        style={{
                            maxHeight,
                            overflow: 'auto',
                            fontSize: '0.85rem',
                            color: '#212529'
                        }}
                    >
                        {JSON.stringify(parsedData, null, 2)}
                    </pre>
                </div>
            )}
        </div>
    );
};

export default JsonViewer;
